import React, { useEffect, useState } from 'react'
import { Box, Table, TableHead, TableRow, TableCell, TableBody, CircularProgress, Divider, Grid } from '@mui/material'
import { ParagraphComp } from '../../../Components/ParagraphComp/ParagraphComp';
import { useQuery } from '@tanstack/react-query';
import { getNpoOperationsDetails } from '../../../Store/npoProfile/npoProfile';
import userIcon from '../../../Assets/img/user_icon.png';
import Chart from 'react-apexcharts';
import ButtonComp from '../../../Components/ButtonComp/ButtonComp';
import { enqueueSnackbar } from 'notistack';

export default function Operations({ orgName, id }) {

  const { data: operationsDetails, isPending: operationsDetailsLoading } = useQuery({
    queryKey: ['operationsDetails', orgName],
    queryFn: () => getNpoOperationsDetails(orgName),
    refetchOnWindowFocus: false,
    enabled: !!orgName
  });

  const [categoriesData, setCategoriesData] = useState([]);

  const ChartOptions = {
    chart: {
      type: 'bar',
      height: 350,
      stacked: true,
      toolbar: {
        show: false
      },
    },
    plotOptions: {
      bar: {
        horizontal: false,
        borderRadius: 4,
        columnWidth: '20%',
        dataLabels: {
          position: 'top',
          total: {
            enabled: true,
            formatter: function() {
              // Calculate total for each stack
              return this.series?.reduce((sum, series) => {
                return sum + (series.data[this.dataPointIndex] || 0);
              }, 0);
            },
            style: {
              fontSize: '12px',
              fontWeight: 900,
              colors: ['#000'] // Black color for totals
            }
          }
        },
      }
    },
    xaxis: {
      categories: categoriesData || [],
      labels: {
        style: {
          fontSize: '12px'
        },
        // This ensures labels are horizontal
        rotate: 0,
        trim: true,
        hideOverlappingLabels: false
      },
      axisTicks: {
        show: false
      }
    },
    yaxis: {
      title: {
        text: 'Number of Team Members',
        style: {
          fontSize: '14px'
        }
      },
      max: 100,
      tickAmount: 10,
      labels: {
        formatter: function(val) {
          return Math.floor(val); // Show whole numbers only
        }
      }
    },
    dataLabels: {
      enabled: true,
      formatter: function(val) {
        return val > 0 ? val : ''; // Only show labels for non-zero values
      },
      offsetY: -20,
      style: {
        // top:'20px',
        fontSize: '12px',
        colors: ["black"] 
      }
    },
    colors: ['#C00000', '#fec74e'], // Blue for full-time, Red for part-time
    legend: {
      position: 'top',
      horizontalAlign: 'center'
    },
    tooltip: {
      enabled: true,
      shared: true,
      intersect: false,
      y: {
        formatter: function(value) {
          return value + " team members";
        }
      }
    }
  }
  
  // In your useEffect where you process the data:
  useEffect(() => {
    const peopleDetails = operationsDetails?.people_engaged_details || [];
  
    if (peopleDetails?.length > 0) {
      const diversityTypes = [];
      const fullTimeTeams = [];
      const partTimeTeams = [];
  
      peopleDetails.forEach((item) => {
        diversityTypes.push(item?.type_of_diversity);
        fullTimeTeams.push(Number(item?.full_time_team || 0));
        partTimeTeams.push(Number(item?.part_time_team || 0));
      });
  
      setCategoriesData(diversityTypes);
      setSeriesData([
        { name: 'Full Time Team', data: fullTimeTeams },
        { name: 'Part Time Team', data: partTimeTeams },
      ]);
    }
  }, [operationsDetails]);

  const [seriesData, setSeriesData] = useState([{ data: [] }]);


  // useEffect(() => {
  //   const peopleDetails = operationsDetails?.people_engaged_details || [];

  //   if (peopleDetails?.length > 0) {
  //     // Initialize arrays to store extracted data
  //     const diversityTypes = [];
  //     const fullTimeTeams = [];
  //     const partTimeTeams = [];

  //     // Single iteration to extract all required data
  //     peopleDetails.forEach((item) => {
  //       diversityTypes.push(item?.type_of_diversity);
  //       fullTimeTeams.push(Number(item?.full_time_team || 0));
  //       partTimeTeams.push(Number(item?.part_time_team || 0));
  //     });

  //     // Update state with extracted data
  //     setCategoriesData(diversityTypes);
  //     setSeriesData([
  //       { name: 'Full Time Team', data: fullTimeTeams },
  //       { name: 'Part Time Team', data: partTimeTeams },
  //     ]);
  //   } else {
  //     // Handle case where no data is present
  //     setSeriesData([{ data: [] }]);
  //   }
  // }, [operationsDetails]);

  const token = localStorage.getItem('NpoToken')

  const openMail = (email) => {
    if (token) {
      const subject = ""; // Replace with your email subject
      const body = ""; // Replace with your email body
      const mailtoLink = `mailto:${email}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;

      // Open the mailto link
      window.location.href = mailtoLink;
    } else {
      enqueueSnackbar('Please register or log in to access email functionality.', { variant: 'warning' });
    }
  };

  const imageStyle = {
    width: '40%', // Make the image fill the container width
    height: 'auto', // Make the image fill the container height
    objectFit: 'contain', // Ensures the image covers the container without stretching
    borderRadius: '5px', // Rounded corners for the image
  };


  return (
    <>
      <div id={id} >
        <Divider sx={{ color: '#E5E8EB', marginTop: '15px', borderBottomWidth: 3 }} />
        <Grid container spacing={2} sx={{ mt: .5 }}>
          <Grid item xs={6}>
            <Box sx={{ backgroundColor: '#004878', padding: '10px', borderRadius: '15px', width: '100%', display: 'flex', alignItems: 'center' }}>
              <ParagraphComp text='Operations' className='text-[white] mt-[0px] mb-[0px] text-2xl  font-bold' />
            </Box>
          </Grid>
        </Grid>
        {operationsDetails ?
          <>
            <Grid container spacing={2} sx={{ mt: .5 }}>
              <Grid item xs={6}>
              </Grid>
              <Grid item xs={6}>
                <ParagraphComp text='Last updated on:' className='text-[black] italic font-thin' />
              </Grid>
            </Grid>
            {operationsDetailsLoading ? <Box sx={{ mt: 5, px: 4, display: 'flex', justifyContent: 'center' }}><CircularProgress /></Box> : <Box sx={{ mt: 3 }}>
              <ParagraphComp text='Management Team' className='text-[#004878] text-2xl mb-3 font-bold' />
              <ParagraphComp text='ˇ SOURCE: Self-reported by organisation ' className='text-[black] text-md mb-[10px] italic font-thin' />
              <Table aria-label="collapsible table">
                <TableHead sx={{ background: '#EDF2F6' }}>
                  <TableRow>
                    <TableCell sx={{ color: '#004878', fontWeight: 600, fontSize: '16px' , width:'25%'}} align="left">Name</TableCell>
                    <TableCell sx={{ color: '#004878', fontWeight: 600, fontSize: '16px' }} align="left">Designation</TableCell>
                    <TableCell sx={{ color: '#004878', fontWeight: 600, fontSize: '16px' }} align="left">Email Id</TableCell>
                    <TableCell sx={{ color: '#004878', fontWeight: 600, fontSize: '16px' , width:'35%'}} align="left" width={180}>Brief Description of person's qualification & experience</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {(operationsDetails?.management_team && operationsDetails?.management_team?.length > 0) ? operationsDetails?.management_team?.map((item, index) =>
                    <TableRow key={index}>
                      <TableCell sx={{ fontSize: '16px' , width:'25%', verticalAlign: 'top'}} align="left">{item?.member_name}</TableCell>
                      <TableCell sx={{ fontSize: '16px' , verticalAlign: 'top'}} align="left">{item?.designation}</TableCell>
                      <TableCell sx={{ fontSize: '16px' , verticalAlign: 'top'}} align="left">
                        {item?.email &&
                          <ButtonComp className='bg-[#004878] px-[10px] py-[5px] text-[white] rounded-full' onClick={() => { openMail(item?.email) }} >
                            View
                          </ButtonComp>
                        }

                      </TableCell>
                      <TableCell sx={{ fontSize: '16px' , width:'35%'}} align="left">{item?.brief_desc || '-'}</TableCell>
                    </TableRow>) : ''}
                </TableBody>
              </Table>
              <Box sx={{ backgroundColor: '#EDF2F6', borderRadius: '16px', padding: '16px', mt: 4 }}>
                <ParagraphComp text={`Compensation per month during FY `} className='text-[#004878] text-2xl mb-3 font-bold' />

                <Box sx={{ display: 'flex' }}>
                  <ParagraphComp text='Highest Paid Staff (₹) :' className='text-[#004878] text-md font-bold w-48' />
                  <ParagraphComp text={operationsDetails?.documents?.[0]?.heighest_paid_staff || '-'} className='text-[#004878] text-md font-normal' />
                </Box>
                <Box sx={{ display: 'flex', mt: 1 }}>
                  <ParagraphComp text='Lowest Paid Staff (₹) :' className='text-[#004878] text-md font-bold w-48' />
                  <ParagraphComp text={operationsDetails?.documents?.[0]?.lowest_paid_staff || '-'} className='text-[#004878] text-md font-normal' />
                </Box>
                <Box sx={{ display: 'flex', mt: 1 }}>
                  <ParagraphComp text='Chief Functionary (₹) :' className='text-[#004878] text-md font-bold w-48' />
                  <ParagraphComp text={operationsDetails?.documents?.[0]?.chief_functionary || '-'} className='text-[#004878] text-md font-normal' />
                </Box>

              </Box>
              <Grid container sx={{ mt: .5 }}>
              <Grid item xs={12} md={12} className='m-auto'>
                  <Box sx={{ mt: 2 }}>
                    <ParagraphComp text='People Engaged (Staff) based on Diversity and Inclusion' className='text-[#004878] text-md font-bold' />
                    {categoriesData.length > 0 && seriesData[0]?.data?.length > 0 ? (
                      <Chart
                        options={ChartOptions}
                        series={seriesData}
                        type="bar"
                        height="350"
                      />
                    ) : (
                      <ParagraphComp text="No team composition data available." />
                    )}
                  </Box>
                </Grid>
                {operationsDetails?.documents?.[0]?.story && <Grid item xs={6}>
                  <Box sx={{ backgroundColor: '#EDF2F6', borderRadius: '16px', padding: '16px', mt: 2, height: '100%' }}>
                    <ParagraphComp text='Story of a team member' className='text-[#004878] text-2xl mb-3 font-bold' />
                    {operationsDetails?.documents?.[0]?.story_image && <img src={`data:image/png;base64,${operationsDetails?.documents?.[0]?.story_image }` || userIcon} style={imageStyle} alt='logo' />}
                    <ParagraphComp text={operationsDetails?.documents?.[0]?.story || '-'} className='text-[#004878] text-md font-normal mt-3 whitespace-pre-line text-justify' />
                  </Box>
                </Grid>}
              </Grid>
            </Box>
            }
          </>
          :
          <ParagraphComp text='No data provided for this section.' className='text-[black] text-xl mt-[20px] font-thin' />
        }
      </div >

    </>
  )
}
